@if (notification) {
  <app-card style="--spacing: 1rem" [class.border]="!notification.readAt">
    <div class="notification-content flex gap-2">
      <div class="icon-circle">
        <app-icon
          *ngIf="notificationContent.icon"
          [name]="notificationContent.icon | icons"
        />
      </div>
      <div class="content">
        <div class="flex">
          <app-tag size="small" [level]="notification.level">
            {{
              LabelConverter.getNotificationLevelLabel(notification.level)
                | translate
            }}
          </app-tag>
          <small>{{ notification.eventDate | relativeDate }}</small>
        </div>
        <h4 class="line-clamp">{{ notificationContent.headline }}</h4>
        <p class="truncate">{{ notificationContent.text }}</p>
      </div>
      @if (hasLink) {
        <button
          type="button"
          class="button icon-button end"
          (click)="markAsReadAndNavigateToRouterLink()"
        >
          <app-icon name="ic_chevron_right" />
        </button>
      }
    </div>
  </app-card>
}
